/**
 * 应用配置文件
 * 从环境变量读取配置，提供默认值
 */

// API配置
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 
           (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8080'),
  version: process.env.REACT_APP_API_VERSION || 'v1',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '300000'), // 默认5分钟
  get fullBaseURL() {
    return `${this.baseURL}/api/${this.version}`;
  }
};

// 应用配置
export const APP_CONFIG = {
  title: process.env.REACT_APP_TITLE || '英语作文智能批改系统',
  env: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
  debug: process.env.REACT_APP_DEBUG === 'true',
  enableMock: process.env.REACT_APP_ENABLE_MOCK === 'true',
  showDevTools: process.env.REACT_APP_SHOW_DEV_TOOLS === 'true',
  defaultLocale: process.env.REACT_APP_DEFAULT_LOCALE || 'zh-CN',
};

// 存储配置
export const STORAGE_CONFIG = {
  tokenKey: process.env.REACT_APP_TOKEN_KEY || 'essay_correction_token',
  userKey: process.env.REACT_APP_USER_KEY || 'essay_correction_user',
};

// 上传配置
export const UPLOAD_CONFIG = {
  maxSize: parseInt(process.env.REACT_APP_MAX_UPLOAD_SIZE || '10485760'),
  allowedTypes: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
};

// 分页配置
export const PAGINATION_CONFIG = {
  defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '10'),
  pageSizeOptions: [10, 20, 50, 100],
};

// 功能开关
export const FEATURES = {
  ocr: process.env.REACT_APP_FEATURE_OCR !== 'false',
  aiCorrection: process.env.REACT_APP_FEATURE_AI_CORRECTION !== 'false',
  export: process.env.REACT_APP_FEATURE_EXPORT !== 'false',
  batchUpload: process.env.REACT_APP_FEATURE_BATCH_UPLOAD === 'true',
};

// 主题配置
export const THEME_CONFIG = {
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#1890ff',
  successColor: process.env.REACT_APP_SUCCESS_COLOR || '#52c41a',
  warningColor: process.env.REACT_APP_WARNING_COLOR || '#faad14',
  errorColor: process.env.REACT_APP_ERROR_COLOR || '#f5222d',
};

// 统计配置
export const STATS_CONFIG = {
  refreshInterval: parseInt(process.env.REACT_APP_STATS_REFRESH_INTERVAL || '60000'),
};

// 监控配置
export const MONITORING_CONFIG = {
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  gaId: process.env.REACT_APP_GA_ID,
};

// 开发环境配置
export const isDevelopment = APP_CONFIG.env === 'development';
export const isProduction = APP_CONFIG.env === 'production';
export const isTest = APP_CONFIG.env === 'test';

// 导出所有配置
const config = {
  api: API_CONFIG,
  app: APP_CONFIG,
  storage: STORAGE_CONFIG,
  upload: UPLOAD_CONFIG,
  pagination: PAGINATION_CONFIG,
  features: FEATURES,
  theme: THEME_CONFIG,
  stats: STATS_CONFIG,
  monitoring: MONITORING_CONFIG,
  isDevelopment,
  isProduction,
  isTest,
};

export default config;